import React, { useEffect } from 'react';
import AcademicCalendar from './AcademicCalendar.jsx';
import { useTranslation } from 'react-i18next';

const AcademicCalendarPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('Akademický kalendár');
  }, []); // Runs on mount

  return (
    <>
      <AcademicCalendar />
    </>
  );
};

export default AcademicCalendarPage;
